import {
    collection,
    doc,
    setDoc,
    getDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    query,
    limit
} from "firebase/firestore";
import { db, trackerDb } from "../config";

// --- Użytkownicy ---

export const getUserData = async (userId) => {
    try {
        const userRef = doc(trackerDb, "users", userId);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
            return { id: userDoc.id, ...userDoc.data() };
        } else {
            return null;
        }
    } catch (error) {
        console.error("Błąd podczas pobierania danych użytkownika:", error);
        throw error;
    }
};

export const createOrUpdateUser = async (userId, userData) => {
    try {
        const userRef = doc(trackerDb, "users", userId);
        const userWithTimestamp = {
            ...userData,
            modifiedAt: new Date().toISOString()
        };

        const existingUser = await getDoc(userRef);
        if (!existingUser.exists()) {
            userWithTimestamp.createdAt = new Date().toISOString();
        }

        await setDoc(userRef, userWithTimestamp, { merge: true });
        return userId;
    } catch (error) {
        console.error("Błąd podczas tworzenia/aktualizacji użytkownika:", error);
        throw error;
    }
};

export const updateUserDisplayName = async (userId, displayName) => {
    try {
        const userRef = doc(trackerDb, "users", userId);
        await updateDoc(userRef, {
            display_name: displayName,
            modifiedAt: new Date().toISOString()
        });
        return userId;
    } catch (error) {
        console.error("Błąd podczas aktualizacji display_name:", error);
        throw error;
    }
};

export const getUserRole = async (userId) => {
    try {
        const userRef = doc(trackerDb, "users", userId);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
            const userData = userDoc.data();
            return userData.role || 'user';
        } else {
            return 'user';
        }
    } catch (error) {
        console.error("Błąd podczas sprawdzania roli użytkownika:", error);
        return 'user';
    }
};

export const updateUserRole = async (userId, role) => {
    try {
        const userRef = doc(trackerDb, "users", userId);
        await updateDoc(userRef, {
            role: role,
            modifiedAt: new Date().toISOString()
        });
        return userId;
    } catch (error) {
        console.error("Błąd podczas aktualizacji roli użytkownika:", error);
        throw error;
    }
};

export const getAllUsers = async () => {
    try {
        const usersRef = collection(trackerDb, "users");
        const querySnapshot = await getDocs(usersRef);

        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error("Błąd podczas pobierania użytkowników:", error);
        throw error;
    }
};

// --- Administratorzy ---

export const isUserAdmin = async (userId) => {
    try {
        const role = await getUserRole(userId);
        return role === 'admin' || role === 'superadmin';
    } catch (error) {
        console.error("Błąd podczas sprawdzania uprawnień administratora:", error);
        return false;
    }
};

export const isUserSuperAdmin = async (userId) => {
    try {
        const role = await getUserRole(userId);
        return role === 'superadmin';
    } catch (error) {
        console.error("Błąd podczas sprawdzania uprawnień superadministratora:", error);
        return false;
    }
};

export const isUserPremium = async (userId) => {
    try {
        const role = await getUserRole(userId);
        return role === 'premium_user' || role === 'admin' || role === 'superadmin';
    } catch (error) {
        console.error("Błąd podczas sprawdzania uprawnień premium:", error);
        return false;
    }
};

export const checkIfAnyAdminExists = async () => {
    try {
        const adminsRef = collection(db, "admins");
        const q = query(adminsRef, limit(1));
        const querySnapshot = await getDocs(q);
        return !querySnapshot.empty;
    } catch (error) {
        console.error("Błąd podczas sprawdzania administratorów:", error);
        return false;
    }
};

export const addAdmin = async (userId, adminData = {}) => {
    try {
        const adminRef = doc(db, "admins", userId);
        await setDoc(adminRef, {
            createdAt: new Date(),
            ...adminData
        });
        return userId;
    } catch (error) {
        console.error("Błąd podczas dodawania administratora:", error);
        throw error;
    }
};

export const removeAdmin = async (userId) => {
    try {
        const adminRef = doc(db, "admins", userId);
        await deleteDoc(adminRef);
        return true;
    } catch (error) {
        console.error("Błąd podczas usuwania administratora:", error);
        throw error;
    }
};

export const getAllAdmins = async () => {
    try {
        const adminsRef = collection(db, "admins");
        const querySnapshot = await getDocs(adminsRef);

        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error("Błąd podczas pobierania administratorów:", error);
        throw error;
    }
};
